import axios from "axios";

axios.defaults.baseURL = `${process.env.REACT_APP_API_URL}`;

// export const PAGE_SIZE = 20;
// export const MAX_LIMIT = 100;

const setHeaders = () => {
  const token = localStorage.getItem("token");

  return {
    headers: token ? { Authorization: `Bearer ${token}` } : {}
  };
};

const setHeadersForFile = () => {
  const token = localStorage.getItem("token");

  return {
    headers: token
      ? {
          Authorization: `Bearer ${token}`,
          "content-type": "multipart/form-data"
        }
      : {}
  };
};

const apiClient = {
  get(url) {
    return axios.get(url, setHeaders());
  },
  delete(url) {
    return axios.delete(url, setHeaders());
  },
  post(url, body) {
    return axios.post(url, body, setHeaders());
  },
  put(url, body) {
    return axios.put(url, body, setHeaders());
  }
};

const apiClientFile = {
  post(url, body) {
    return axios.post(url, body, setHeadersForFile());
  }
};

// Auth
const login = credentials => axios.post("/auth/login", credentials);
const logout = () => apiClient.get("/auth/logout");
const forgotPassword = email => apiClient.post(`/auth/password/email`, email);
const resetPassword = newCredentials =>
  axios.post("/auth/password/reset", newCredentials);

// Company
const fetchCompanies = () => axios.get(`/company/all`);
const searchCompanies = query => axios.get(`/company/all?query=${query}`);
const createCompany = company => apiClient.post(`/company/store`, company);
const updateCompany = company => {
  const id = localStorage.getItem("Company:Id");
  return apiClient.put(`/company/update/${id}`, company);
};
const updateCompanyById = ({ companyId, ...rest }) =>
  apiClient.put(`/company/update/${companyId}`, rest);

const getSOW = id => apiClient.get(`/project/sow/show/${id}`);
const acceptSow = payload => apiClient.post(`/project/sow/accept`, payload);
const getPitch = id => apiClient.get(`/project/pitches/show/${id}`);
const getPitchesByProjectId = projectId =>
  apiClient.get(`/project/pitches/all?project_id=${projectId}`);
const getCompanyById = companyId => apiClient.get(`company/show/${companyId}`);
const completeProjectByEmployer = id =>
  apiClient.put(`/project/update/${id}`, { status_id: 12 });

const createCompanyPayment = payload =>
  apiClient.post(`/company/payment/store`, payload);
const updateCompanyPayment = (id, payload) =>
  apiClient.put(`/company/payment/update/${id}`, payload);
const getCompanyPaymentById = id => apiClient.get(`company/payment/show/${id}`);

// Dropdowns
const getReferrals = () => axios.get("/dropdown/referral");
const getIndustries = () => axios.get("/dropdown/industry");
const getCompanySizes = () => axios.get("/dropdown/company-size");
const getSchools = () => axios.get("/dropdown/school");
const searchSchools = query => axios.get(`/dropdown/school?query=${query}`);
const createSchools = value => axios.post(`/dropdown/school/store`, { value });
const getWorkRelationships = () => axios.get("/dropdown/work-relationship");
const getProjectDurations = () => axios.get("/dropdown/project-duration");
const getJobTypes = () => axios.get("/dropdown/project-job-type");
const getWorkTypes = () => axios.get("/dropdown/project-work-type");
const getTaxStatus = () => axios.get("/dropdown/project-tax-status");
const getProjectBudgetRateTypes = () =>
  axios.get("/dropdown/project-budget-rate-type");
const getCommuteCities = () => axios.get("/dropdown/commute-cities");
const getLevels = () => axios.get("/dropdown/level");
const getReferenceRelationships = () =>
  axios.get("/dropdown/work-relationship-v2");
const getCompanyBudgets = () => axios.get("/dropdown/company-budget");
const getCompanyPaymentMethods = () =>
  axios.get("/dropdown/company-payment-method");
const getCompanyPaymentTerms = () =>
  axios.get("/dropdown/company-payment-term");

// Skills
const getSkills = () => axios.get("/skill/all");
const getCategories = () => axios.get("/skill/category/all");

// User
const createEmployer = employer =>
  axios.post(`/user/registration/employer`, employer);
const createCandidate = candidate =>
  axios.post(`/user/registration/member`, candidate);
const updateUser = user => apiClient.put(`/user/update`, user);
const updateUserProfile = profile =>
  apiClient.put(`/user/profile/update`, profile);
const getUserData = () => apiClient.get(`/user/show`);
const getUserStats = () => apiClient.get(`/user/stats`);
const verifyCreditCard = creditCard =>
  apiClient.post("/user/verify/credit-card", creditCard);
const verifyReferralCode = referralCode =>
  apiClient.post("/user/verify/referral-code", referralCode);
const uploadResume = formData =>
  apiClientFile.post(`/user/resume/upload`, formData);
const getMemberById = memberId =>
  apiClient.get(`/user/profile/member/${memberId}`);
const downloadResume = userId =>
  apiClient.get(`/user/resume/download/${userId}`);
const getUserStatusList = () => apiClient.get("/user/status/all");

// Email Preferences
const getEmailTypes = () => apiClient.get("/user/email/types");
const getEmailTypesOptions = () => apiClient.get("/user/email/options");
const updateEmailPreferences = payload =>
  apiClient.put("/user/email/update", payload);

// Project
const createProject = project => apiClient.post("/project/store", project);
const getProject = projectId => apiClient.get(`/project/show/${projectId}`);
const getProjects = () => apiClient.get("/project/all");
const updateProject = (project, projectId) => {
  return apiClient.put(`/project/update/${projectId}`, project);
};
const unpauseProject = projectId =>
  apiClient.get(`/project/status/restart/${projectId}`);
const completeProjectByMember = projectId =>
  apiClient.put(`/project/status/complete/${projectId}`);
const getStatus = () => apiClient.get(`/project/status/all`);
const checkReviewer = payload =>
  apiClient.post("project/review/state", payload);
const storeReview = payload => apiClient.post("/project/review/store", payload);
const getReviewQuestionsForEmployer = () =>
  apiClient.get("/project/review/questions/employer");

// Matches
const getMatches = () => apiClient.get("/project/matches");
const getMatch = id => apiClient.get(`/project/matches/show/${id}`);
const getPitches = () => apiClient.get("/project/pitches/all");
const getStatements = () => apiClient.get("/project/sow/all");
const getHired = () => apiClient.get("/project/hired");
const declineMatch = payload =>
  apiClient.post("/project/matches/decline", payload);
const storePitch = payload => apiClient.post("/project/pitches/store", payload);
const updatePitch = (id, payload) =>
  apiClient.put(`/project/pitches/update/${id}`, payload);
const acceptPitch = payload =>
  apiClient.post("/project/pitches/accept", payload);
const undoPitch = payload => apiClient.post("/project/pitches/undo", payload);
const storeSOW = payload => apiClient.post("/project/sow/store", payload);
const updateSOW = (id, payload) =>
  apiClient.put(`/project/sow/update/${id}`, payload);
const getReviewQuestionsForMember = () =>
  apiClient.get("/project/review/questions/member");

// Messages
const getMessagesByPitchId = pitchId =>
  apiClient.get(`/project/messages/show/${pitchId}`);
const sendMessage = payload =>
  apiClient.post("/project/messages/store", payload);
const updateMessage = (messageId, payload) =>
  apiClient.post(`/project/messages/update/${messageId}`, payload);
const removeMessage = messageId =>
  apiClient.post(`/project/messages/destroy/${messageId}`);
const downloadMessageAttachment = messageId =>
  apiClient.get(`/project/messages/attachment/${messageId}`);

// Cities
const searchCitiesAutocomplete = input =>
  apiClient.post("/gmaps/autocomplete", { input });
const searchNearbyCities = (lat, lng) =>
  apiClient.post("/gmaps/nearby-cities", { lat, lng });
const getPlaceDetails = place_id =>
  apiClient.post("/gmaps/place-details", { place_id });

// Work References
const getQuestions = () => axios.get("/user/work-references/check/questions");
const checkState = refId =>
  axios.post("/user/work-references/check/state", refId);
const getReference = refId =>
  axios.get(`/user/work-references/check/public/${refId}`);
const declineReference = payload =>
  axios.post("/user/work-references/check/decline", payload);
const createReference = reference =>
  axios.post("/user/work-references/check/store", reference);

//Admin
const getUser = userId => apiClient.get(`/admin/user/show/${userId}`);
const adminUpdateUser = payload =>
  apiClient.post("/admin/user/update", payload);
const adminRemoveUser = userId =>
  apiClient.delete(`/admin/user/destroy/${userId}`);
const adminApproveReference = payload =>
  apiClient.post("/admin/user/reference/approval", payload);
const adminSendReminderReference = payload =>
  apiClient.post("/admin/user/reference/reminder", payload);
const adminAddReference = payload =>
  apiClient.post("/admin/user/reference/add", payload);
const getAdminProjects = filters =>
  apiClient.get(`/admin/project/all${filters}`);
const getAdminProjectsForCSV = filters =>
  apiClient.get(`/admin/project/all?csv=1${filters}`);
const getAdminCompanyById = companyId =>
  apiClient.get(`/admin/company/show/${companyId}`);
const getAdminCompanies = filters =>
  apiClient.get(`/admin/user/employers${filters}`);
const getAdminCompaniesForCSV = filters =>
  apiClient.get(`/admin/user/employers?csv=1${filters}`);
const runMatchAll = () => apiClient.get("/project/matches/lambda/all");
const getAdminProjectsOverview = () =>
  apiClient.get("/admin/dashboard/projects/overview");
const adminUpdateProject = payload =>
  apiClient.post("/admin/project/update", payload);
const createAdmin = payload =>
  apiClient.post("/admin/user/store/admin", payload);
const getReferralCodes = () => apiClient.get("/admin/referral-code/all");
const updateReferralCode = payload =>
  apiClient.put("/admin/referral-code/update", payload);
const createReferralCode = () => apiClient.get("/admin/referral-code/generate");
const getAdminMembers = filters =>
  apiClient.get(`/admin/user/members${filters}`);
const getAdminMembersForCSV = filters =>
  apiClient.get(`/admin/user/members?csv=1${filters}`);
const getAdminProject = (projectId, filters = "") =>
  apiClient.get(`/admin/project/show/${projectId}${filters}`);
const getAdminProjectMatches = (projectId, filters = "") =>
  apiClient.get(`/admin/project/matches/${projectId}${filters}`);
const getAdminProjectMatchesForCSV = (projectId, filters = "") =>
  apiClient.get(
    `/admin/project/matches/${projectId}${filters}${filters ? "&" : "?"}csv=1`
  );
const getAdminProjectFeed = projectId =>
  apiClient.get(`/admin/project/feed/${projectId}`);
const getAdminDashboardTodo = () => apiClient.get("/admin/dashboard/todo");
const getAdminMembersOverview = () =>
  apiClient.get("/admin/dashboard/users/overview");
const getAdminWeeklyProjects = () =>
  apiClient.get("/admin/dashboard/projects/weekly");
const getAdminWeeklyUsers = () =>
  apiClient.get("/admin/dashboard/users/weekly");
const getAdminList = () => apiClient.get("/admin/user/admins");
const notifyProjectMatches = payload =>
  apiClient.post("/admin/project/matches/notify", payload);

// Admin Notes
const getAdminUserNotes = userId =>
  apiClient.get(`/admin/user/notes/show/${userId}`);
const saveAdminUserNotes = payload =>
  apiClient.post("/admin/user/notes/store", payload);
const getAdminProjectNotes = projectId =>
  apiClient.get(`/admin/project/notes/show/${projectId}`);
const saveAdminProjectNotes = payload =>
  apiClient.post("/admin/project/notes/store", payload);
const getAdminCompanyNotes = companyId =>
  apiClient.get(`/admin/company/notes/show/${companyId}`);
const saveAdminCompanyNotes = payload =>
  apiClient.post("/admin/company/notes/store", payload);

// Invoice
const getInvoices = () => apiClient.get("/invoice/all");
const getInvoice = invoiceId => apiClient.get(`/invoice/show/${invoiceId}`);
const createInvoice = invoice => apiClient.post("/invoice/store", invoice);
const updateInvoice = (id, invoice) => {
  return apiClient.put(`/invoice/update/${id}`, invoice);
};
const removeInvoice = invoiceId => {
  return apiClient.post(`/invoice/destroy/${invoiceId}`);
};
const uploadInvoice = formData =>
  apiClientFile.post(`/invoice/upload`, formData);
const downloadInvoice = invoiceId =>
  apiClient.get(`/invoice/download/${invoiceId}`);
const getInvoiceStatus = () => apiClient.get("/invoice/status/all");
const getInvoiceStatusById = activityId =>
  apiClient.get(`/invoice/status/show/${activityId}`);
const createInvoiceStatus = activity =>
  apiClient.post("/invoice/status/store", activity);
const updateInvoiceStatus = (id, activity) => {
  return apiClient.put(`/invoice/status/update/${id}`, activity);
};
const getAdminInvoices = filters =>
  apiClient.get(`/admin/invoice/all${filters}`);
const getAdminInvoicesForCSV = filters =>
  apiClient.get(`/admin/invoice/all?csv=1${filters}`);
const getAdminInvoiceById = invoiceId =>
  apiClient.get(`/admin/invoice/show/${invoiceId}`);

export default {
  login,
  logout,
  searchCompanies,
  completeProjectByEmployer,
  fetchCompanies,
  createCompany,
  getReferrals,
  getIndustries,
  getCompanySizes,
  getSchools,
  searchSchools,
  createSchools,
  getWorkRelationships,
  getSkills,
  createEmployer,
  createCandidate,
  updateUser,
  getUserData,
  getUserStats,
  updateCompany,
  updateCompanyById,
  getCategories,
  getProjectDurations,
  getJobTypes,
  getWorkTypes,
  getTaxStatus,
  getProjectBudgetRateTypes,
  createProject,
  getProject,
  updateProject,
  forgotPassword,
  resetPassword,
  getProjects,
  getHired,
  verifyCreditCard,
  verifyReferralCode,
  searchCitiesAutocomplete,
  searchNearbyCities,
  getPlaceDetails,
  getMatches,
  getMatch,
  declineMatch,
  getPitches,
  getStatements,
  getQuestions,
  checkState,
  getReference,
  declineReference,
  createReference,
  storePitch,
  updatePitch,
  getSOW,
  acceptSow,
  getPitch,
  storeSOW,
  getPitchesByProjectId,
  getMemberById,
  updateSOW,
  acceptPitch,
  getMessagesByPitchId,
  sendMessage,
  updateMessage,
  removeMessage,
  uploadResume,
  downloadResume,
  getEmailTypes,
  getEmailTypesOptions,
  updateEmailPreferences,
  getCompanyById,
  downloadMessageAttachment,
  completeProjectByMember,
  getUserStatusList,
  getUser,
  adminUpdateUser,
  adminRemoveUser,
  adminApproveReference,
  adminSendReminderReference,
  adminAddReference,
  getAdminProjects,
  getAdminProjectsForCSV,
  getStatus,
  getAdminCompanyById,
  getAdminCompanies,
  getAdminCompaniesForCSV,
  runMatchAll,
  getReviewQuestionsForMember,
  getReviewQuestionsForEmployer,
  storeReview,
  checkReviewer,
  getAdminProjectsOverview,
  adminUpdateProject,
  createAdmin,
  getReferralCodes,
  updateReferralCode,
  createReferralCode,
  getAdminMembers,
  getAdminMembersForCSV,
  getAdminProject,
  getAdminProjectMatches,
  getAdminProjectMatchesForCSV,
  getAdminProjectFeed,
  getAdminDashboardTodo,
  getAdminMembersOverview,
  getAdminWeeklyProjects,
  getAdminWeeklyUsers,
  getCommuteCities,
  getLevels,
  getCompanyBudgets,
  getCompanyPaymentMethods,
  getCompanyPaymentTerms,
  unpauseProject,
  getReferenceRelationships,
  undoPitch,
  getAdminUserNotes,
  saveAdminUserNotes,
  getAdminProjectNotes,
  saveAdminProjectNotes,
  getAdminCompanyNotes,
  saveAdminCompanyNotes,
  updateUserProfile,
  notifyProjectMatches,
  getAdminList,
  getInvoices,
  getInvoice,
  createInvoice,
  updateInvoice,
  removeInvoice,
  uploadInvoice,
  downloadInvoice,
  getInvoiceStatus,
  getInvoiceStatusById,
  createInvoiceStatus,
  updateInvoiceStatus,
  createCompanyPayment,
  updateCompanyPayment,
  getCompanyPaymentById,
  getAdminInvoices,
  getAdminInvoicesForCSV,
  getAdminInvoiceById
};



// WEBPACK FOOTER //
// ./src/services/api.js